import { useTranslation } from 'react-i18next'

import { ChatCircleDotsIcon } from '@ui/icons/ChatCircleDots.icon'

import { MenuSection } from '../useMenuSections'

export const useShowContactSupport = (): MenuSection => {
  const { t } = useTranslation()

  return {
    id: 'show-contact-support',
    label: t('Contact Us'),
    icon: ChatCircleDotsIcon,
    onClick: () => {
      const event = new CustomEvent('show-chat-fab')
      document.dispatchEvent(event)
    },
  }
}
